import { ApprovalRequiredOperation } from "@zapier/utils";
import useAccountRestriction from "../account/useAccountRestriction";
import useRequiresApproval from "./useRequiresApproval";

export function useIsApprovalRequiredForZap({
  zapId,
  isZapPublished,
  operation,
}: {
  zapId?: string;
  isZapPublished?: boolean;
  operation: ApprovalRequiredOperation;
}): boolean {
  const { isPublishApprovalEnabled } = useAccountRestriction();

  const { publishedRequiresApproval, pauseRequiresApproval } =
    useRequiresApproval({
      zapId,
      enabled: !!zapId,
    });

  if (!isPublishApprovalEnabled) {
    return false;
  }

  if (operation === ApprovalRequiredOperation.TurnOff) {
    return publishedRequiresApproval && pauseRequiresApproval;
  }

  // Turn on/toggle zap is always on the published version
  if (operation === ApprovalRequiredOperation.Toggle) {
    return publishedRequiresApproval;
  }

  // Delete drafts is allowed, even through the server returns
  // that the draft requires approval. This is unfortunate,
  // needs some cleanup on the API side.
  return isZapPublished ? publishedRequiresApproval : false;
}
